import { COLOR, Tag, type TagProps } from '@cosuno/cosuno-ui';

import useTranslation from '~/shared/hooks/useTranslation';

export const AiTag: React.FC<Omit<TagProps, 'gradient'>> = (props) => {
  const { t } = useTranslation();

  return (
    <Tag
      {...props}
      leftIcon={{ type: 'stars' }}
      solidBackground
      gradient={{
        direction: '163deg',
        colors: [
          { color: COLOR.aiGradientTop, position: '38.59%' },
          { color: COLOR.aiGradientBottom, position: '101.54%' },
        ],
      }}
    >
      {t('ai')}
    </Tag>
  );
};
